export enum ErrorCode {
  UNKNOWN = -1,
  VALIDATION_ERROR = 100,
  INVALID_INPUT_FORMAT = 200,
  UNAUTHENTICATED = 300,
}